import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { CoatingLine, PretreatmentType } from '@workspace-app/odatabackend/QualicoatBackendModel';
import { LineExtensionDto } from '../../services/license-number-data.service';

@Component({
  selector: 'app-line-extensions-selector',
  standalone: true,
  imports: [FormsModule, TableModule, CheckboxModule, InputTextModule, Select],
  templateUrl: './line-extensions-selector.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./line-extensions-selector.component.scss'],
})
export class LineExtensionsSelectorComponent {
  @Input() set coatingLines(lines: CoatingLine[]) {
    if (lines && lines.length > 0) {
      this._lineExtensions = lines.map((line) => ({
        lineId: line.id,
        designation: line.designation,
        pretreatment: line.pretreatment ?? null,
        seaside: line.seaside ?? false,
        postforming: line.postforming ?? false,
      }));
      this.emitChange();
    }
  }

  @Output() lineExtensionsChange = new EventEmitter<LineExtensionDto[]>();

  _lineExtensions: LineExtensionDto[] = [];

  pretreatmentOptions = [
    { label: 'None', value: null },
    { label: 'Chromate', value: PretreatmentType.Chromate },
    { label: 'Chemical', value: PretreatmentType.Chemical },
    { label: 'Pre-Anodising', value: PretreatmentType.PreAnodising },
  ];

  onValueChange() {
    this.emitChange();
  }

  private emitChange() {
    this.lineExtensionsChange.emit(this._lineExtensions);
  }

  get lineExtensions(): LineExtensionDto[] {
    return this._lineExtensions;
  }
}
